<template>
    <div class="prissues">
        <b-container fluid>
            <b-row>
                <b-col cols="4">
                    <b-row><b-col><SchedaMacchina v-if="!!machine" :m="machine" :info="false" :key="machine.upd" /></b-col></b-row>
                    <b-row v-if="closed"><b-col><div class=closed>{{closed}}</div></b-col></b-row>
                    <b-row><b-col><Locations v-if="!!machine" :key="machine.upd" /></b-col></b-row>
                    <b-row><b-col><OpenPointsStatus v-if="!!machine" :m="machine" :info="false" :key="machine.upd" /></b-col></b-row>
                    <b-row><b-col><OpenPointsMachine v-if="!machine" :info="false" /></b-col></b-row>
                    <b-row><b-col><OpenPointsStatus v-if="!machine" :info="false" /></b-col></b-row>
                </b-col>
                <b-col>
                    <OpenPoints :noAdd="false" height="calc(100vh - 455px)"/>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { API } from "@/api.js";
import SchedaMacchina from "@/components/SchedaMacchina.vue";
import OpenPointsStatus from "@/components/OpenPointsStatus.vue";
import OpenPointsMachine from "@/components/OpenPointsMachine.vue";
import OpenPoints from "@/components/OpenPoints.vue";
import Locations from "@/components/Locations.vue";

export default {
    name: "PIIssues",
    components: {
        SchedaMacchina,
        OpenPointsStatus,
        OpenPoints,
        Locations,
        OpenPointsMachine,
    },
    data: function () {
        return {
            owners: [{ value: "Marsilli", text: "Marsilli" }, { value: "Customer", text: "Customer" }],
            closed: false,
        }
    },
    props: {
        
    },
    async mounted(){
		this.$nextTick(async () => {
			let k = 1;
            if(this.machine) {
                this.machine.image = "/images/units/" + this.machine.img;
                this.machine.upd = k++;
            }
		});
    },
    watch: {
        machine: async function() {
            let checkStato = await API.getUnitstatus(this.machine.codice);
            console.log("checkStato", checkStato);
            if(checkStato && checkStato.length>0 && checkStato[0].status != this.section) {
                this.closed = `Closed and moved to ${checkStato[0].status} on ${checkStato[0].ts.split("T")[0]}`;
            } else {
                this.closed = false;
            }
        }
    },
    computed: {
        machine() {
            return this.$store.getters.machine;
        },
        section(){
            return this.$store.getters.section
        },
    },
    methods: {
        addIssue(){
            console.log("addIssue")
            this.formIssue = { no: 0, ts: null, duets: null, line: "", swunit: "", issue: "", owner: "", catid: null, respid: null, phaseid: null, statusid: null, prioritylevel: 1, },
            this.addIssueDlg = true
        },
        async onSubmitIssue(){
            this.formIssue.unit = this.machine.codice
            console.log("onSubmitIssue",this.formIssue)
            await API.addIssue(this.formIssue,this.section)
            // this.gridApi.redrawRows()
            this.issues = await API.prinIssues(this.machine.codice, this.section)
            this.issues = this.issues.map((i,idx) => ({...i, no: idx+1, ts: new Date(i.ts), duets: new Date(i.duets)}))
            this.addIssueDlg = false
            this.$store.commit("incPStates",null);
        },
        onResetIssue(){
            console.log("onResetIssue")
            this.addIssueDlg = false
        },
        dateFormatter(params) {
            return params.value.toLocaleDateString();
        },
		async onRowDoubleClicked(params){
			console.log("rowDoubleClicked2",params.data)
            this.$store.commit("issue", params.data);
            this.$router.push("/practions");
        },
        onGridReady(params) {
			console.log("Grid Ready")
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
			// this.columnApi.applyColumnState({
			// 	state: [{ colId: 'datefrom', sort: 'desc' }],
			// 	defaultState: { sort: null },
			// });
        },
		// eslint-disable-next-line no-unused-vars
        onFirstDataRendered(event) {
            if(this.currTab==0) {
                this.columnApi.autoSizeAllColumns();
				console.log("autoSizeAllColumns1")
			}
        },

    }
}

</script>
<style>
div.prissues div.card {
    margin: 0px !important;
}
</style>
<style scoped>
div.closed {
    right: 0px;
    background-color: #9a240d !important;
    border-color: #9a240d !important;
    position: relative;
    top: 5px;
    color: white;
    margin-bottom: 10px;
    padding: 25px;
    font-weight: 700;
}
div.prissues {
    padding: 10px;
    padding-top: 60px;
    background-color: #d3d3d3;
}
div.prissues button {
	background-color: #9a240d !important;
	border-color: #9a240d !important;
	margin-bottom: 10px;
}
div.prissues button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.prissues button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.title {
    /* text-align: left; */
    font-weight: 700;
    background-color: white;
}
</style>
